import React, { useState, useEffect, useRef } from "react";
import "./selectCard.css";
import { useTranslation } from "react-i18next";
import upload from "../../Assets/Icons/upload.svg";
import trash from "../../Assets/Icons/trash.svg";
import { FaTimes } from "react-icons/fa";
import ToastPopup from "../Toast/toastPopup";

const SelectCard = ({ image, setImage, title, selectedId, front, onImageUpload, disabled }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showDel, setShowDel] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (showModal) {
      setVisible(true);
    }
  }, [showModal]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseWithTransition();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
  
    const validFiles = files.filter(file => {
      const fileSizeKB = file.size / 1024;
      if (fileSizeKB > 0 && fileSizeKB <= 2048) { 
        return true;
      } else {
        if (fileSizeKB > 2048) {
          ToastPopup.error(t("imageSizeWarn"));
        } else {
          ToastPopup.error(t("selectValidImage"));
        }
        return false;
      }
    });
  
    if (validFiles.length > 0) {
      processFiles(validFiles);
    }
    e.target.value = "";
  };
  

  const handleDelete = () => {
    setImage("");
  };

  const handleShowImg = () => {
    setShowModal(true);
    setTimeout(() => {
      setShowDel(true);
    }, 300);
  };

  const handleCloseWithTransition = () => {
    setVisible(false);
    setShowDel(false);
    setTimeout(() => {
      setShowModal(false);
    }, 300);
  };
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const files =  Array.from(e.dataTransfer.files);
    const validFiles = files.filter(file => {
      const fileSizeKB = file.size / 1024;
      if (fileSizeKB > 0 && fileSizeKB <= 2048) { 
        return true;
      } else {
        if (fileSizeKB > 2048) {
          ToastPopup.error(t("imageSizeWarn"));
        } else {
          ToastPopup.error(t("selectValidImage"));
        }
        return false;
      }
    });
  
    if (validFiles.length > 0) {
      processFiles(validFiles);
    }
  };

  const processFiles = (files) => {
    const validImageTypes = ["image/jpeg", "image/png", "image/webp"];
    const imageFiles = files.filter((file) => validImageTypes.includes(file.type));

    if (imageFiles.length > 0) {
      onImageUpload({ files: imageFiles });
    } else {
      ToastPopup.error(t('warnImg'));
    }
  };

  return (
    <div>
      <p className="select-card-title select-card-nurse">
        {selectedId ? (front ? t("frontPageOf") : t("backPageOf")) + selectedId : t(title)}
      </p>
      <div
        className={`select-card-container ${image && "selected"} ${isDragging && "drag-over"}`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        {image ? (
          <div className="img-selected">
            <img src={image} alt="Selected" className="selected-card" onClick={handleShowImg} />
            <button className={`card-delete-btn ${disabled ? "hide-delete" : ""}`} onClick={handleDelete}>
              <img src={trash} alt="delete" />
            </button>
          </div>
        ) : (
          <label className={`upload-card ${disabled ? "disabled" : ""}`}>
            <input type="file" accept="image/*" onChange={handleImageChange} className="file-input-card" disabled={disabled} />
            <img src={upload} alt="upload" />
            <p className="upload-text-card">{t("dragNdrop")}</p>
            <p className="upload-text-card">{t("or")}</p>
            <p className="upload-card-btn">{t("browseFile")}</p>
          </label>
        )}
      </div>

      {showModal && (
        <div className="show-id-preview">
          <div className="id-pos-rel">
            <button className={`card-delete-btn close ${showDel ? "modal-open" : "modal-close"}`} onClick={() => handleCloseWithTransition()}>
              <FaTimes color="white" />
            </button>
            <img src={image} className={`show-id-img-prev ${visible ? "modal-open" : "modal-close"}`} ref={modalRef} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectCard;
